type RenderOnboardingProps = {
    readonly consentStatus?: 'no' | 'outdated' | 'yes';
    readonly onboardingRoutesPath: string;
    readonly pathname: string;
    readonly userProfileExists: boolean;
};

type SuppressAnnouncementsProps = {
    readonly isConsentResolved: boolean;
    readonly isOnboardingActive: boolean;
    readonly isUserProfileResolved: boolean;
    readonly consentStatus?: 'no' | 'outdated' | 'yes';
    readonly userProfileExists: boolean;
};

export const shouldRenderOnboarding = ({
    consentStatus,
    onboardingRoutesPath,
    pathname,
    userProfileExists,
}: RenderOnboardingProps): boolean => {
    const currentPathnameIsNotOnboarding = pathname !== onboardingRoutesPath;

    return (
        (consentStatus !== 'yes' && currentPathnameIsNotOnboarding) ||
        (userProfileExists === false && currentPathnameIsNotOnboarding)
    );
};

export const shouldSuppressAnnouncements = ({
    consentStatus,
    isConsentResolved,
    isOnboardingActive,
    isUserProfileResolved,
    userProfileExists,
}: SuppressAnnouncementsProps): boolean => {
    if (isOnboardingActive) {
        return true;
    }

    if (!isUserProfileResolved) {
        return false;
    }

    if (userProfileExists === false) {
        return true;
    }

    if (!isConsentResolved) {
        return false;
    }

    return consentStatus !== 'yes';
};
